var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerSourceLineSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #d47500;\n      }\n\n      .st1 {\n        fill: #0f1f3c;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M584.8,478.7l41.1-39.7c-34-35.2-74.6-61.5-119.2-77.6,38.6-31.5,63.4-79.4,63.4-133,0-94.5-76.9-171.4-171.4-171.4s-171.4,76.9-171.4,171.4,25.1,102.2,64.1,133.7c-120.1,44.2-205.9,159.8-205.9,295.1h57.1c0-141.8,115.4-257.1,257.1-257.1,70.5,0,136.3,27.9,185.2,78.6h0ZM398.7,114.3c63,0,114.3,51.2,114.3,114.3s-51.2,114.3-114.3,114.3-114.3-51.3-114.3-114.3,51.3-114.3,114.3-114.3Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.1,447.6l179.2,179.2,65.6-244.8-244.8,65.6ZM619.7,508.7l-29.5-29.5,40.4-10.8-10.9,40.3Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M386.9,709l244.8-65.6-179.2-179.2-65.6,244.8h0ZM484.1,582.2l29.5,29.5-40.4,10.8,10.9-40.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerSourceLineSvgrepoCom);
export default __webpack_public_path__ + "static/media/customer-source-line-svgrepo-com.7d3471614e6d6f01d10c035ad3549397.svg";
export { ForwardRef as ReactComponent };